import {z} from 'zod'
import {SUBACC_DETAILS} from '@/subaccount'
import {TRANSACTIONS} from '@/transaction'
import {INVOICE_VIEW} from '@/invoice'
import {OCR_TRANSACTION_VIEW} from '@/bank'
import {PanelContentRequest} from '@tritt/multipanel'
import {DOCUMENT_VIEW} from '@/document'

export const ResourceLinkSchema = z.object({
    system: z.string(),
    tenantId: z.string(),
    type: z.string(),
    identifier: z.string(),
    display: z.string()
})

export type ResourceLink = z.infer<typeof ResourceLinkSchema>

export const resolvePanelContent = (resourceLink: ResourceLink): PanelContentRequest | undefined => {
    // TODO Great naming of panel contents
    // TODO register like the routes
    const panelContentMap: Map<string, PanelContentRequest> = new Map([
        ['customer', {...SUBACC_DETAILS, queryValues: {subAccountUuid: resourceLink.identifier}} as PanelContentRequest],
        ['sub_account', {...SUBACC_DETAILS, queryValues: {subAccountUuid: resourceLink.identifier}} as PanelContentRequest],
        ['supplier', {...SUBACC_DETAILS, queryValues: {subAccountUuid: resourceLink.identifier}} as PanelContentRequest],
        ['transaction', {...TRANSACTIONS, queryValues: {transactionUuid: resourceLink.identifier}}],
        ['invoice', {...INVOICE_VIEW, queryValues: {invoiceUuid: resourceLink.identifier}}],
        ['ocr_transaction', {...OCR_TRANSACTION_VIEW, queryValues: {transactionUuid: resourceLink.identifier}}],
        ['document', {...DOCUMENT_VIEW, queryValues: {documentMetaUuid: resourceLink.identifier}}],
    ])
    return panelContentMap.get(resourceLink.type)
}